import { render, staticRenderFns } from "./BotaoRankingLojas.vue?vue&type=template&id=6ae5c580&scoped=true&"
import script from "./BotaoRankingLojas.vue?vue&type=script&lang=js&"
export * from "./BotaoRankingLojas.vue?vue&type=script&lang=js&"
import style0 from "./BotaoRankingLojas.vue?vue&type=style&index=0&id=6ae5c580&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5c580",
  null
  
)

export default component.exports